import { defaultOptions, deserify } from "@karmaniverous/serify-deserify"
import { RootState } from "app/store"
import { UserParameters } from "features/userParameters/UserParametersSchema"
import { useSelector } from "react-redux"

export function useLastSubmittedUserParameters(): UserParameters | null {
  return useSelector((state: RootState) => {
    const serialized = state.lastSubmittedParameters.parameters
    if (!serialized) {
      return null
    }
    return deserify(serialized, defaultOptions) as UserParameters
  })
}
